import gql from 'graphql-tag'

export const DEFAULT_LEAD_VALUES = {
  name: '',
    email: '',
    role: '',
    existingProduct: false,
    marketLocation: '',
    designStatus: '',
    productTarget: '',
    productStyle: '',
    productModel: '',
    productId: null,
    productThumbnail: '',
    productThumbnailBack: '',
    retailCost: '',
    comments: '',
    calendlyId: '',
    timezone: '',
    validatedSteps: 0,
  }

export const fragments = {
  lead: gql`
    fragment leadFields on Lead {
      id
      name
      email
      role
      existingProduct
      marketLocation
      designStatus
      productTarget
      productStyle
      productModel
      productId
      productThumbnail
      productThumbnailBack
      retailCost
      comments
      calendlyId
      timezone
      validatedSteps
      updatedAt
      createdAt
    }
  `
}

export const GET_ALL_LEADS_QUERY = gql`
  query leads($page: Int) {
    leads(page: $page, limit: 10) {
      collection {
        ...leadFields
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
  ${fragments.lead}
`

export const GET_LEAD_QUERY = gql`
  query leads($id: String!) {
    lead(id: $id) {
      ...leadFields
    }
  }
  ${fragments.lead}
`

export const CREATE_LEAD_MUTATION = gql`
  mutation createLead($lead: LeadInput!) {
    leads: createLead(lead: $lead) {
      ...leadFields
    }
  }
  ${fragments.lead}
`

export const UPDATE_LEAD_MUTATION = gql`
  mutation updateLead($id: String!, $lead: LeadInput!) {
    leads: updateLead(id: $id, lead: $lead) {
      ...leadFields
    }
  }
  ${fragments.lead}
`

export const DELETE_LEAD_MUTATION = gql`
  mutation deleteLead($ids: [String!]!) {
    leads: deleteLead(ids: $ids) {
      ...leadFields
    }
  }
  ${fragments.lead}
`
